// @flow

import React, {useEffect, useState} from 'react';

import Box from 'sail/Box';
import {TextInput} from 'sail/Input';

import tinycolor from 'tinycolor2';

import './ColorPicker.scss';

type ColorPickerProps = {
  value: string,
  onBlur: (string) => void,
};

export const ColorPicker = ({value, onBlur}: ColorPickerProps) => {
  const [valueState, setValueState] = useState<string>(value);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <Box className="ColorPicker">
      <Box
        className="ColorPicker-appearanceColorPreview"
        style={{
          backgroundColor: valueState,
          borderRight: '1px solid rgba(0, 0, 0, 0.05)',
          color: tinycolor(valueState).isDark() ? 'white' : 'black',
        }}
      >
        {'#'}
      </Box>
      <TextInput
        className="ColorPicker-appearanceColorTextInput"
        value={valueState.replace('#', '') || ''}
      />
      <input
        className="ColorPicker-appearanceColorInput"
        type="color"
        value={valueState || ''}
        onBlur={() => onBlur(valueState)}
        onChange={(e) => setValueState(e.target.value)}
      />
    </Box>
  );
};
